import { createContext } from "react";

// A page can register its own data loader; otherwise the layout remounts the view.
const RefreshContext = createContext(null);

export default RefreshContext;
